











import Vue from 'vue';

import api from '@/common/api';
import { JsonApiSingleResponse } from '@/jsonApi.types';
import { initValidationErrors, ValidationErrors } from '@/common/validation/validation.types';
import { Feature } from '@/features.types';
import PageLoader from '@/common/components/PageLoader.vue';
import LoadingModal from '@/common/components/LoadingModal.vue';
import {
  HostedPaymentPageResponse,
  HostedPaymentPageUpdate,
} from '@/common/types/hostedPaymentPages.types';
import { createUpdateModel, initHostedPaymentPage, HppFieldAttribute } from '@/common/util/hostedPaymentPages.util';
import HostedPaymentPageEditor from './HostedPaymentPageEditor.vue';

const SAVING_LOADING_TEXT: string = 'Saving...';

export default Vue.extend({
  props: {
    id: {
      type: String,
      required: false,
      default: '',
    },
  },
  data() {
    return {
      Feature,
      isSubmitting: false,
      loadingText: SAVING_LOADING_TEXT as string,
      hppData: initHostedPaymentPage() as HostedPaymentPageUpdate,
      validationErrors: initValidationErrors() as ValidationErrors,
      showShippingFieldsFlag: false as boolean,
    };
  },
  mounted() {
    if (!this.id) {
      (this.$refs.loader as any).setReady();
      return;
    }
    api
      .get(`/hosted-payments/${this.id}`)
      .then(({ data: { data } }) => {
        const hppData = createUpdateModel(data);
        const cols = hppData.config[0].columns;
        Object.keys(cols).forEach((key: any) => {
          const colArr = cols[key];
          Object.keys(colArr.fields).forEach((fieldKey: any) => {
            if (colArr.fields[fieldKey].name === 'shippingEnabled') {
              const shippingBtnLabel = (colArr.fields[fieldKey].attributes as HppFieldAttribute).label;
              if (shippingBtnLabel === 'Hide shipping information') {
                this.showShippingFieldsFlag = true;
              }
            }
          });
        });

        this.hppData = hppData;
        (this.$refs.loader as any).setReady();
      })
      .catch(() => {
        this.$toasted.error('Problem loading hosted payment page');
        (this.$refs.loader as any).setError();
      });
  },
  methods: {
    submitActions(isSubmitting: boolean, loadingText: string = SAVING_LOADING_TEXT) {
      this.isSubmitting = isSubmitting;
      this.loadingText = loadingText;
    },
    showSuccess({ data }: { data: JsonApiSingleResponse<HostedPaymentPageResponse> }) {
      this.submitActions(false);
      this.$toasted.success('Hosted payment page saved successfully!');
      this.$router.push({ name: 'merchant.hosted-payments.view', params: { id: data.data!.id! } });
    },
    handleSaveError(response: any) {
      this.submitActions(false);
      this.$toasted.error(
        `There was a problem saving the hosted payment page. (${response.status})`,
      );
      this.validationErrors = response.data.errors || {};
    },
  },
  components: {
    PageLoader,
    HostedPaymentPageEditor,
    LoadingModal,
  },
});
